import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import { Modal, ModalFooter, ModalHeader } from 'components/Modal'
import { City } from '../../data/models/funnelOrder/cities'
import { destinationEnum } from '../../data/models/funnelOrder/destination'
import {
  filterDestination,
  getExcludedCitiesContentKey as getExcludeCitiesContentKey,
} from '../../data/models/funnelOrder/excludedCities'
import { Theme } from '../../data/models/funnelOrder/theme'
import {
  mapPerBasicLanguageToPerCountry,
  PerBasicLanguage,
  SiteCountry,
} from '../../data/models/locale'
import { AppState } from '../../data/state'
import { getCoronaLink } from '../../urls/corona'
import FlyExcludedCities from '../excluded/FlyExcludedCities'

interface FlyExcludeModalProps {
  theme: Theme
  excludedCities: City[]
  destination: destinationEnum
  max?: number
  backButton?: boolean
  hideClose?: boolean
  icon?: JSX.Element
  country: SiteCountry
  onClose: () => void
  setExcludedCities(value: City[]): void
}

interface FlyExcludeModalState {
  excludedCities: City[]
}

class FlyExcludeModal extends React.Component<
  FlyExcludeModalProps,
  FlyExcludeModalState
> {
  constructor(props: FlyExcludeModalProps) {
    super(props)
    this.state = {
      excludedCities: props.excludedCities,
    }
  }

  public render() {
    const {
      country,
      theme,
      destination,
      backButton,
      hideClose,
      icon,
      onClose,
    } = this.props

    const contentContentKey = getExcludeCitiesContentKey(theme, destination)

    const contentKeys = {
      content: contentContentKey,
      subContent: 'corona-virus-content',
    }

    return (
      <Modal
        size="xl"
        sticky
        contentOverflow
        modalName="excludedCitiesModal"
        onDismiss={onClose}
      >
        <ModalHeader
          backButton={backButton}
          icon={icon}
          iconProps={{
            width: '37',
            height: '37',
            viewBox: '0 0 37 41',
            fill: 'none',
          }}
        >
          <DisplayContent contentKey="exclude-cities-title">
            Exclude cities
          </DisplayContent>
        </ModalHeader>

        <div className="content">
          <p>
            <DisplayContent contentKey={contentKeys.content}>
              Exclude cities
            </DisplayContent>
          </p>

          <p>
            <a href={getCoronaLink(country)} target="_blank">
              <DisplayContent contentKey={contentKeys.subContent}>
                {`Exclude cities subcontent`}
              </DisplayContent>
            </a>
          </p>

          <FlyExcludedCities
            excludedCities={this.state.excludedCities}
            destination={destination}
            max={this.props.max}
            setExcludedCities={this.setExcludedCities}
          />
        </div>
        <ModalFooter
          hideClose={hideClose}
          onClose={onClose}
          onSave={this.handleSave}
        />
      </Modal>
    )
  }

  private handleSave = () => {
    const filtered = filterDestination(
      this.state.excludedCities,
      this.props.theme,
      this.props.destination || destinationEnum.allOfEurope,
    )
    this.props.setExcludedCities(filtered)
    this.props.onClose()
  }

  private setExcludedCities = (excludedCities: City[]) => {
    this.setState({ excludedCities })
  }
}

export default connect(
  (state: AppState) => ({
    excludedCities: state.funnelOrder.excludedCitiesIds,
    theme: state.funnelOrder.theme,
    country: state.locale.country,
  }),
  dispatch => ({
    setExcludedCities: (value: City[]) => {
      dispatch(actions.change('funnelOrder.excludedCitiesIds', value))
    },
  }),
)(FlyExcludeModal)
